// extracted by mini-css-extract-plugin
export default {"inner":"SecurityPage_inner__x8JID","sidebar":"SecurityPage_sidebar__Bfch1","content":"SecurityPage_content__3q1aM"};